import React, { useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Icon } from 'antd';
import PropTypes from 'prop-types';

import EmailInfoModal from '../modals/EmailInfoModal';

function EmailInput(props) {
    const [isModalVisible, setModalVisiblity] = useState(false);
    const { errorMessage, intl, isValid } = props;

    const onChange = (event) => {
        props.onChange({
            target: {
                name: 'email',
                value: event.target.value,
            },
        });
    };

    const displayModal = () => {
        setModalVisiblity(!isModalVisible);
    };

    return (
        <div className="input-elem-sto">
            <div className="tooltip-input-label">
                <label htmlFor="email">
                    <FormattedMessage id={props.label} />
                </label>
                <button className="tooltip-button" onClick={displayModal} type="button">
                    <Icon className="popup-hint login-page-popup-hint" id="info-icon" type="question-circle" />
                </button>
            </div>

            <input
                autoComplete="off"
                className={`input-sto text ${isValid === false ? 'hasError ' : 'isValid'}`}
                disabled={props.disabled}
                id="email"
                maxLength={40}
                name="email"
                onBlur={props.onBlur}
                onChange={onChange}
                onClick={props.onClick}
                onFocus={props.onFocus}
                placeholder={intl.formatMessage({ id: props.placeholder })}
                type="text"
                value={props.value}
            />

            <p className={`input-sto-placeholder input-sto-placeholder-error ${isValid !== false ? 'hidden' : ''}`}>
                {errorMessage && <FormattedMessage id={errorMessage} />}
            </p>

            <EmailInfoModal onOk={displayModal} visible={isModalVisible} />
        </div>
    );
}

EmailInput.propTypes = {
    disabled: PropTypes.bool,
    displayPlaceholder: PropTypes.bool,
    errorMessage: PropTypes.string,
    isValid: PropTypes.bool,
    maxLength: PropTypes.number,
    minLength: PropTypes.number,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onClick: PropTypes.func,
    onFocus: PropTypes.func,
    placeholder: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.string,
};

EmailInput.defaultProps = {
    isValid: null,
};

export default injectIntl(EmailInput);
